import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';

// import * as React from "react";
// import { DataGrid } from "@mui/x-data-grid";
// import { useNavigate } from "react-router-dom";
// import IconButton from "@mui/material/IconButton";
// import VisibilityIcon from "@mui/icons-material/Visibility";

// export default function DataGridTable(tabledata) {
//     // console.log("data12",tabledata)
//     const navigate = useNavigate();

//     const handleRowClick = (params) => {
//         // navigate(`/pages-starter/${row.sno}`);
//         navigate(`/individualteacher`, { state: { teacherName: params.row.tname } });
//     };

//     const columns = [
//         { field: "sno", headerName: "S.no", width: 100 },

//         {
//             field: "Period",
//             headerName: "Period",
//             width: 250  ,
//         },
//         {
//             field: "Status",
//             headerName: "Status",
//             width: 200,
//         },
//         {
//             field: "Engagement",
//             headerName: "Engagement",
//             width: 280,
//         },
//         {
//             field: "Health",
//             headerName: "Health",
//             width: 230,
//         },
//         {
//             field: "Studentini",
//             headerName: "Student Initiated Conversations",
//             width: 230,
//         },

//     ];

//     const rows = Array.isArray(tabledata) ? tabledata.map((item, index) => ({
//         sno: index + 1,
//         Period: item.unit_name,
//         Status: item.status,
//         Engagement: item.engagement,
//         Health: item.student_health,
//         Studentini: item.student_initiated_conversations,
//     })) : [];  // Fallback to empty array if tabledata is not an array

//     // console.log("rows",rows)

//     return (
//         <div style={{ width: "100%" }}>
//             <DataGrid
//                 rows={rows}
//                 columns={columns}
//                 pageSize={5}
//                 rowsPerPageOptions={[5, 10, 25]}
//                 pagination
//                 onRowClick={handleRowClick}
//                 autoHeight // This prop allows the grid to automatically adjust its height based on the number of rows
//                 sx={{
//                     fontFamily: "Nunito Sans, sans-serif",
//                     fontSize: "14px",
//                     "& .MuiDataGrid-columnHeaders": {
//                         backgroundColor: "#ebebeb",
//                         color: "#000",
//                         fontWeight: "bold",
//                         fontSize: "14px",
//                         padding: "6px",
//                         fontFamily: "Nunito Sans, sans-serif",
//                     },
//                     "& .MuiDataGrid-cell": {
//                         padding: "6px",
//                         fontFamily: "Nunito Sans, sans-serif",
//                         fontSize: "14px",
//                     },
//                     "& .MuiDataGrid-row:hover": {
//                         cursor: "pointer",
//                         backgroundColor: "#f5f5f5",
//                     },
//                 }}
//             />
//         </div>
//     );
// }

export default function DataGridTable({ tabledata }) {
  // Destructure tabledata directly
  // console.log("tabledata received:", tabledata);
  const navigate = useNavigate();

  const handleRowClick = (params) => {
    navigate(`/#`, { state: { teacherName: params.row.tname } });
  };

  const columns = [
    { field: 'sno', headerName: 'S.no', width: 100 },
    { field: 'unitname', headerName: 'Unit', width: 400 },
    { field: 'TeacherName', headerName: 'Teacher', width: 400 },
    { field: 'Period', headerName: 'Period', width: 400 },
    { field: 'Status', headerName: 'Status', width: 200 },
    { field: 'Engagement', headerName: 'Engagement', width: 280 },
    { field: 'Health', headerName: 'Health', width: 230 },
    {
      field: 'Studentini',
      headerName: 'Student Initiated Conversations (%)',
      width: 230,
    },
  ];


  console.log({tabledata})
  // Map tabledata to create rows for DataGrid
  const rows = Array.isArray(tabledata)
    ? tabledata[0]?.map((item, index) => ({
        id: index + 1, // DataGrid requires a unique `id` field
        sno: index + 1,
        unitname: item.unit_name,
        TeacherName: item.teacher_name,
        Period: item.period,
        Status: item.status,
        Engagement: item.engagement,
        Health: item.student_health,
        Studentini: item.student_initiated_conversations,
      }))
    : [];

  return (
    <div style={{ width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={5}
        rowsPerPageOptions={[5, 10, 25]}
        pagination
        // onRowClick={handleRowClick}
        autoHeight
        sx={{
          'fontFamily': 'Nunito Sans, sans-serif',
          'fontSize': '14px',
          '& .MuiDataGrid-columnHeaders': {
            backgroundColor: '#ebebeb',
            color: '#000',
            fontWeight: 'bold',
            fontSize: '14px',
            padding: '6px',
          },
          '& .MuiDataGrid-cell': {
            padding: '6px',
          },
          '& .MuiDataGrid-row:hover': {
            cursor: 'pointer',
            backgroundColor: '#f5f5f5',
          },
        }}
      />
    </div>
  );
}
